import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import {
	Stack,
	Grid,
	Paper,
	Box,
	Button,
	TextField,
	MenuItem,
	Typography,
	LinearProgress,
	useMediaQuery,
	Breadcrumbs,
	FormControl,
	InputLabel,
	Select,
	RadioGroup,
	Radio,
	FormControlLabel,
	ButtonGroup,
} from '@mui/material'

import {
	DataGridPremium,
	koKR,
	GridSelectionModel,
	GridDensity,
	useGridApiRef,
	GridRowModesModel,
	GridRowsProp,
	GridToolbar,
	GridRowParams,
} from '@mui/x-data-grid-premium'
import { styled, useTheme } from '@mui/material/styles'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'

import { selectuserInfo } from 'hooks/userInfo'
import { getSettings } from 'helpers/storage'

import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import { alertModal, compareDate, hexToRgba, isValidDateType } from 'util/util'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import { apiSBList, apiSBReceptionListV2 } from 'api/api'

import { PageBg } from 'components/ComponentStyles'

import moment from 'moment'
import 'moment/locale/ko'
import ClientSearchPopup from './clientSearchPopup'
import { valuesInIterator } from 'util/objectUtil'

import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule'
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit'

const locales = ['ko'] as const

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

const SearchRowItem = styled(Box)(({ theme }) => ({
	position: 'relative',
	display: 'block',
	paddingLeft: '80px',
	minHeight: '44px',
	marginBottom: '10px',
	'&.noLabel': {
		paddingLeft: '0',
	},
	'.labelText': {
		position: 'absolute',
		left: '10px',
		top: '15px',
		[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
			position: 'relative',
			left: '0',
			top: '0',
			marginBottom: '0.5rem',
		},
	},
	[`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
		paddingLeft: '0',
		height: 'auto',
	},
}))

const SlideBlockResultPage = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))

	const userInfo = useSelector(selectuserInfo)

	const env = getSettings()

	const [locale, setLocale] = useState<(typeof locales)[number]>('ko')

	// ui state
	const [disabledSave, setDisabledSave] = useState(true)
	const [disabledDel, setDisabledDel] = useState(true)
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [disabledReset, setDisabledReset] = useState(false)

	const [dateRange, setDateRange] = useState('1d')

	const [search, setSearch] = useState({
		clientID: userInfo.ClientID,
		chartNo: '',
		patientName: '',
		socialNumber: '',
		pathologyNo: '',
		status: '0',
		step: '0',
		startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
		endDate: moment().format('YYYY-MM-DD'),
		searchType: 'D',
		printState: 'A',
	})

	const actionReset = () => {
		setSearch({
			clientID: userInfo.ClientID,
			chartNo: '',
			patientName: '',
			socialNumber: '',
			pathologyNo: '',
			status: '0',
			step: '0',
			startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			searchType: 'R',
			printState: 'A',
		})
		// setPopupData({})
		setSelectedSbList([])
	}

	const actionSearch = () => {
		console.table(search)

		// 내부사용자이고 clientID가 없으면
		if (
			(userInfo.infoType === 'S' ||
				userInfo.infoType === 'W' ||
				userInfo.manageGName === '신원본원') &&
			search.clientID === ''
		) {
			alertModal('거래처를 선택해주세요.', 'error', () => {})
			return
		}

		if (moment(search.startDate).isBefore('2023-08-01')) {
			setSearch({
				...search,
				startDate: '2023-08-01',
			})
		}

		if (search.socialNumber) {
			if (search.socialNumber.length !== 8) {
				alertModal('주민번호는 뒤 1자리까지 입력하세요.', 'error', () => {})
				return
			} else {
				const regexp = /^\d{6}-[1-8]$/g
				if (!regexp.test(search.socialNumber)) {
					alertModal('주민번호 형식이 올바르지 않습니다.', 'error', () => {})
					return
				}
			}
		}

		const request = {
			clientID: search.clientID as any,
			patientName: search.patientName,
			chartNo: search.chartNo,
			startDate: moment(search.startDate).isBefore('2023-08-01')
				? '2023-08-01'
				: search.startDate,
			endDate: search.endDate,
			socialNumber: search.socialNumber,
			pathologyNo: search.pathologyNo,
			status: search.status,
			step: search.step,
			searchType: search.searchType,
		}

		console.log(request)

		mstRef.current?.setPage(0)
		// remove all selected rows
		mstRef.current?.setSelectionModel([])

		setGridMstLoading(true)

		apiSBReceptionListV2(request)
			.then((res) => {
				console.log(res)
				setRows(res)
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				setGridMstLoading(false)
			})
	}

	const [sbList, setSbList] = useState([])
	const [selectedSbList, setSelectedSbList] = useState<any[]>([])

	// grid state
	const mstRef = useGridApiRef()
	const [rows, setRows] = useState([])
	const [gridMstLoading, setGridMstLoading] = useState(false)
	const [gridMstPageSize, setGridMstPageSize] = useState(env.row ? env.row : 100)

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({})

	const [editRows, setEditRows] = useState<GridRowsProp>([])
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	// calcaulate today before n days
	const getBeforeDate = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'days').format('YYYY-MM-DD'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1d':
				getBeforeDate(1)
				break
			case '3d':
				getBeforeDate(3)
				break
			case '7d':
				getBeforeDate(7)
				break
			default:
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event
	const dateRanageOnChange = (e: any, target: string) => {
		if (moment(new Date(e)).isBefore('2023-08-01')) {
			alertModal('2023-08-01 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				startDate: '2023-08-01',
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM-DD').length === 10) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)

					setSearch((prevState) => {
						return {
							...search,
							[target]: moment(new Date(e)).format('yyyy-MM-DD'),
						}
					})
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})									
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...search,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue < -1825) {
						alertModal('검색기간은 5년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...search,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)

						setSearch((prevState) => {
							return {
								...search,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
					if (diffValue > 1825) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						
						setSearch((prevState) => {
							return {
								...search,
								[target]: moment(new Date(e)).format('yyyy-MM-DD'),
							}
						})
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...search,
						[target]: moment(new Date(e)).format('yyyy-MM-DD'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	const actionPrint = (type: string) => {
		const selectedRows = mstRef.current?.getSelectedRows()
		// extract ReceptionID in selectedRows
		const values = valuesInIterator(selectedRows)
		if (values.length === 0) {
			alertModal('출력할 슬라이드를 선택해주세요.', 'error', () => {})
			return
		}
		// values에서 ReceptionID만 추출해서 쉼표로 구분된 문자열로 변환
		const tRequestWebIdsArr = values.map((item: any) => {
			return item.TRequestWebID
		})
		console.log(tRequestWebIdsArr)
		const tRequestWebIds = tRequestWebIdsArr.join(',')
		const receptionIDsArr = values.map((item: any) => {
			return item.ReceptionID
		})
		console.log(receptionIDsArr)
		const receptionIDs = receptionIDsArr.join(',')
		// apiSlideBlockDocument(request).then((res) => console.log(res))
		window.open(
			`${process.env.REACT_APP_HOST}/rpt/slideDocument?searchType=${
				search.searchType
			}&startDate=${search.startDate}&endDate=${search.endDate}&step=${
				search.step
			}&receptionIDs=${receptionIDs}&tRequestWebIds=${tRequestWebIds}&clientID=${
				userInfo.infoType === 'S' || userInfo.infoType === 'W'
					? search.clientID
					: userInfo.clientID
			}&zoom=100&status=0&type=${type}`,
			'결과보고서',
			'width=900, height=1000'
		)
	}

	useEffect(() => {
		// if (userInfo?.branchCode !== 'B01201') {
		// 	alertModal('접근 권한이 없습니다.', 'error', () => {})
		// 	return
		// }
		if (userInfo?.infoType === 'C') actionSearch()
		apiSBList().then((res) => {
			let resultList: [] = []
			if (userInfo?.isEhwa) {
				resultList = res.filter((x: any) => x.DisplayName.includes('이화'))
			} else {
				resultList = res.filter((x: any) => !x.DisplayName.includes('이화'))
			}
			setSbList(resultList)
		})
	}, [])

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								슬라이드 대여 조회
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									{/* <Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <LocalPrintshopIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										// disabled={selectionModel.length === 0}
										onClick={actionPrint}
									>
										반출확인서출력
									</Button> */}
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <HorizontalRuleIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={selectionModel.length === 0}
										onClick={() => actionPrint('single')}
									>
										건별출력
									</Button>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <HorizontalSplitIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={selectionModel.length === 0}
										onClick={() => actionPrint('all')}
									>
										일괄출력
									</Button>
								</span>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <ContentPasteSearchTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledSearch}
										onClick={actionSearch}
									>
										조회
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="status-select-label112">검사진행상태</InputLabel>
										<Select
											labelId="status-select-label112"
											id="status-simple-select112"
											label="검사진행상태"
											value={search.step}
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													step: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>
											<MenuItem
												value={'1'}
												sx={{ color: '#f39c12' }}
											>
												접수
											</MenuItem>
											<MenuItem
												value={'2'}
												sx={{ color: '#2980b9' }}
											>
												완료
											</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="status-select-label11">반출상태</InputLabel>
										<Select
											labelId="status-select-label11"
											id="status-simple-select11"
											label="반출상태"
											value={search.status}
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													status: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>
											<MenuItem
												value={'2'}
												sx={{ color: '#f39c12' }}
											>
												반출신청
											</MenuItem>
											<MenuItem
												value={'3'}
												sx={{ color: '#27ae60' }}
											>
												반출중
											</MenuItem>
											<MenuItem
												value={'4'}
												sx={{ color: '#2980b9' }}
											>
												반출완료
											</MenuItem>
											<MenuItem
												value={'1'}
												sx={{ color: '#c0392b' }}
											>
												반출불가
											</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="searchType-select-label112">기간유형</InputLabel>
										<Select
											labelId="searchType-select-label112"
											id="searchType-simple-select112"
											label="기간유형"
											value={search.searchType}
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													searchType: e.target.value,
												})
											}}
										>
											<MenuItem value={'R'}>접수일</MenuItem>
											<MenuItem value={'D'}>신청일</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="시작일"
										value={search.startDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										label="종료일"
										value={search.endDate}
										mask={'____-__-__'}
										inputFormat={'YYYY-MM-DD'}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
										}}
										renderInput={(params) => (
											<TextField
												size="small"
												{...params}
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									{isLgUp ? (
										<>
											<FormControl sx={{ pt: 0.8 }}>
												<RadioGroup
													row
													aria-labelledby="date-controlled-radio-buttons-group"
													name="date-radio-buttons-group"
													value={dateRange}
													onChange={searchDateRanageOnChange}
													sx={{ ml: '0.5rem' }}
												>
													<FormControlLabel
														value="1d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="1일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="3d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="3일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
													<FormControlLabel
														value="7d"
														control={<Radio sx={{ padding: '1px' }} />}
														label="7일"
														sx={{
															'& .MuiFormControlLabel-label': { fontSize: '12px' },
														}}
													/>
												</RadioGroup>
											</FormControl>
										</>
									) : (
										<>
											<FormControl fullWidth>
												<InputLabel id="date-range-select-label">조회 기간</InputLabel>
												<Select
													labelId="date-range-select-label"
													id="date-range-simple-select"
													value={dateRange}
													label="조회 기간"
													onChange={searchDateRanageOnChange}
													size={'small'}
												>
													<MenuItem value={'0'}>선택하세요.</MenuItem>
													<MenuItem value={'1d'}>1일</MenuItem>
													<MenuItem value={'3d'}>3일</MenuItem>
													<MenuItem value={'7d'}>7일</MenuItem>
												</Select>
											</FormControl>
										</>
									)}
								</Grid>
							</Grid>
						</SearchRowItem>
						<SearchRowItem>
							<p className="labelText">검색조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={6}
									md={6}
									lg={3}
								>
									<TextField
										label="차트번호"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.chartNo}
										onChange={(e) => {
											setSearch({
												...search,
												chartNo: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={6}
									md={6}
									lg={3}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.patientName}
										onChange={(e) => {
											setSearch({
												...search,
												patientName: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={6}
									md={6}
									lg={3}
								>
									<FormControl fullWidth>
										<InputLabel id="print-state-select-label">출력상태</InputLabel>
										<Select
											labelId="print-state-select-label"
											id="print-state-simple-select"
											value={search.printState}
											label="출력상태"
											onChange={(e) => {
												setSearch({
													...search,
													printState: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'A'}>선택하세요.</MenuItem>
											<MenuItem value={'N'}>미출력</MenuItem>
											<MenuItem value={'Y'}>출력</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								{(userInfo.infoType === 'S' ||
									userInfo.infoType === 'W' ||
									userInfo.manageGName === '신원본원') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={3}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
					<Typography
						key="4"
						color="primary"
						sx={{ fontWeight: '500', fontSize: 13.7, ml: 1 }}
					>
						신청 취소 및 수정은 병리학부(02-801-5135/5137) 로 문의 바랍니다.
					</Typography>
				</Box>
			</Stack>
			<Paper
				elevation={0}
				sx={{ width: '100%', overflow: 'hidden', mt: 2 }}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg>
							<Box
								sx={{
									height: 'calc(100vh - 325px)',
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<DataGridPremium
									rows={rows}
									apiRef={mstRef}
									experimentalFeatures={{ newEditingApi: true }}
									rowModesModel={rowModesModel}
									selectionModel={selectionModel}
									checkboxSelection
									isRowSelectable={(params: GridRowParams) =>
										params.row.StateCode === 'CP'
									}
									onSelectionModelChange={(newSelection) => {
										setSelectionModel(newSelection)
									}}
									columns={[
										// {
										// 	field: 'rowNum',
										// 	headerName: '순번',
										// 	type: 'number',
										// 	width: 60,
										// 	editable: false,
										// 	headerAlign: 'center',
										// 	renderCell: (params) => {
										// 		const { IRStateCode, rowNum } = params.row
										// 		if (IRStateCode === 'RQ') {
										// 			return <span style={{ color: '#f39c12' }}>{rowNum}</span>
										// 		} else if (IRStateCode === 'CF') {
										// 			return <span style={{ color: '#16a085' }}>{rowNum}</span>
										// 		} else if (IRStateCode === 'CP') {
										// 			return <span style={{ color: '#2980b9' }}>{rowNum}</span>
										// 		} else if (IRStateCode === 'IM') {
										// 			return <span style={{ color: '#c0392b' }}>{rowNum}</span>
										// 		}
										// 	},
										// },
										{
											field: 'ReceptionID',
											headerName: 'ID',
											type: 'number',
											width: 80,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ReceptionID } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ReceptionID}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ReceptionID}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ReceptionID}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ReceptionID}</span>
												}
											},
										},
										{
											field: 'id',
											headerName: '순번',
											type: 'number',
											width: 60,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												// const { RentalState, rowNum } = params.row
												// if (RentalState === '반출신청') {
												// 	return <span style={{ color: '#f39c12' }}>{rowNum}</span>
												// } else if (RentalState === '반출중') {
												// 	return <span style={{ color: '#27AE60' }}>{rowNum}</span>
												// } else if (RentalState === '반출완료') {
												// 	return <span style={{ color: '#2980b9' }}>{rowNum}</span>
												// }
												const { IRStateCode, id } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{id}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{id}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{id}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{id}</span>
												} else {
													return <span>{id}</span>
												}
											},
										},
										{
											field: 'PartCode',
											headerName: '파트코드',
											type: 'string',
											width: 80,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, PartCode } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{PartCode}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{PartCode}</span>
												} else if (IRStateCode === 'CP') {
													return <span style={{ color: '#2980b9' }}>{PartCode}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{PartCode}</span>
												}
											},
										},
										{
											field: 'ClientName',
											headerName: '의뢰기관명',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ClientName } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ClientName}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ClientName}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ClientName}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ClientName}</span>
												}
											},
										},
										{
											field: 'RegDate',
											headerName: '신청일자',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, RegDate } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{RegDate}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{RegDate}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{RegDate}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{RegDate}</span>
												}
											},
										},
										{
											field: 'ReceptionDate',
											headerName: '접수일자',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ReceptionDate } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ReceptionDate}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ReceptionDate}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ReceptionDate}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ReceptionDate}</span>
												}
											},
										},
										{
											field: 'ReceptionRegNum',
											headerName: '접수번호',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ReceptionRegNum } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ReceptionRegNum}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ReceptionRegNum}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ReceptionRegNum}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ReceptionRegNum}</span>
												}
											},
										},
										{
											field: 'PathologyNo',
											headerName: '병리번호',
											type: 'string',
											width: 150,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, PathologyNo } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{PathologyNo}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{PathologyNo}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{PathologyNo}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{PathologyNo}</span>
												}
											},
										},
										{
											field: 'PatientName',
											headerName: '수진자명',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, PatientName } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{PatientName}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{PatientName}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{PatientName}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{PatientName}</span>
												}
											},
										},
										{
											field: 'ChartNo',
											headerName: '차트번호',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ChartNo } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ChartNo}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ChartNo}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ChartNo}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ChartNo}</span>
												}
											},
										},
										{
											field: 'ClientInfo',
											headerName: '성별/나이',
											type: 'string',
											width: 85,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ClientInfo } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ClientInfo}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ClientInfo}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ClientInfo}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ClientInfo}</span>
												}
											},
										},
										{
											field: 'TestCode',
											headerName: '검사코드',
											type: 'string',
											width: 90,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, TestCode } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{TestCode}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{TestCode}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{TestCode}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{TestCode}</span>
												}
											},
										},
										{
											field: 'ReTestCodes',
											headerName: '신청내용',
											type: 'string',
											width: 300,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, ReTestCodes } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{ReTestCodes}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{ReTestCodes}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{ReTestCodes}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{ReTestCodes}</span>
												}
											},
										},
										{
											field: 'RequestNotes',
											headerName: '비고',
											type: 'string',
											width: 300,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, RequestNotes } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{RequestNotes}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{RequestNotes}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{RequestNotes}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{RequestNotes}</span>
												}
											},
										},
										{
											field: 'DisplayName',
											headerName: '검사명',
											type: 'string',
											width: 220,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, DisplayName } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{DisplayName}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{DisplayName}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{DisplayName}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{DisplayName}</span>
												}
											},
										},
										{
											field: 'IRStateCode',
											headerName: '반출상태',
											type: 'string',
											width: 100,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode } = params.row
												/**
												 * StateCode 값 분류
												 * RQ : 요청
												 * CF : 반출중
												 * CP : 반출완료
												 * IM : 반출취소
												 */
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>반출신청</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>반출중</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>반출완료</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>반출불가</span>
												}
											},
										},
										{
											field: 'CompleteNotes',
											headerName: '처리내용',
											type: 'string',
											width: 220,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IRStateCode, CompleteNotes } = params.row
												if (IRStateCode === 'RQ') {
													return <span style={{ color: '#f39c12' }}>{CompleteNotes}</span>
												} else if (IRStateCode === 'CF') {
													return <span style={{ color: '#16a085' }}>{CompleteNotes}</span>
												} else if (IRStateCode === 'CP' || IRStateCode === 'SD') {
													return <span style={{ color: '#2980b9' }}>{CompleteNotes}</span>
												} else if (IRStateCode === 'IM') {
													return <span style={{ color: '#c0392b' }}>{CompleteNotes}</span>
												}
											},
										},
										{
											field: 'IsPrinted',
											headerName: '반출확인서 출력여부',
											type: 'string',
											width: 150,
											editable: false,
											headerAlign: 'center',
											renderCell: (params) => {
												const { IsPrinted } = params.row
												return IsPrinted ? (
													<span
														style={{
															color: '#fff',
															background: '#c0392b',
															display: 'block',
															borderRadius: '20px',
															padding: '0.2rem 1rem',
															width: '80px',
															textAlign: 'center',
															margin: '0 auto',
														}}
													>
														출력
													</span>
												) : (
													<span
														style={{
															color: '#fff',
															background: '#16a085',
															display: 'block',
															borderRadius: '20px',
															padding: '0.2rem 1rem',
															width: '80px',
															textAlign: 'center',
															margin: '0 auto',
														}}
													>
														미출력
													</span>
												)
											},
										},
										{
											field: 'PrintedDate',
											headerName: '출력일자/시간',
											type: 'string',
											width: 155,
											editable: false,
											headerAlign: 'center',
										},
										// {
										// 	field: 'SpecimenName',
										// 	headerName: '검체명',
										// 	type: 'string',
										// 	width: 150,
										// 	editable: false,
										// 	headerAlign: 'center',
										// 	renderCell: (params) => {
										// 		const { RentalState, SpecimenName } = params.row
										// 		if (RentalState === '반출신청') {
										// 			return <span style={{ color: '#f39c12' }}>{SpecimenName}</span>
										// 		} else if (RentalState === '반출중') {
										// 			return <span style={{ color: '#27AE60' }}>{SpecimenName}</span>
										// 		} else if (RentalState === '반출완료') {
										// 			return <span style={{ color: '#2980b9' }}>{SpecimenName}</span>
										// 		}
										// 	},
										// },
										// {
										// 	field: 'RentalState',
										// 	headerName: '반출상태',
										// 	type: 'string',
										// 	width: 100,
										// 	editable: false,
										// 	headerAlign: 'center',
										// 	renderCell: (params) => {
										// 		const { RentalState } = params.row
										// 		if (RentalState === '반출신청') {
										// 			return <span style={{ color: '#f39c12' }}>{RentalState}</span>
										// 		} else if (RentalState === '반출중') {
										// 			return <span style={{ color: '#27AE60' }}>{RentalState}</span>
										// 		} else if (RentalState === '반출완료') {
										// 			return <span style={{ color: '#2980b9' }}>{RentalState}</span>
										// 		}
										// 	},
										// },
									]}
									pageSize={gridMstPageSize}
									onPageSizeChange={(newPageSize) => setGridMstPageSize(newPageSize)}
									rowsPerPageOptions={[5, 10, 20, 50, 100]}
									pagination
									autoHeight={false}
									localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
									loading={gridMstLoading}
									components={{
										Toolbar: GridToolbar,
										LoadingOverlay: LinearProgress,
									}}
									componentsProps={{
										toolbar: {
											csvOptions: { disableToolbarButton: true },
											excelOptions: { disableToolbarButton: true },
											printOptions: { disableToolbarButton: true },
											showQuickFilter: false,
											quickFilterProps: { debounceMs: 250 },
										},
									}}
									density={(env.desnse as GridDensity) || 'compact'}
									initialState={{
										columns: {
											columnVisibilityModel: {
												ReceptionID: false,
												rowNum: false,
												ReceptionRegNum: false,
												ClientInfo: false,
												TestCode: false,
												SpecimenName: false,
											},
										},
									}}
									sx={{
										'& .MuiDataGrid-columnHeaderTitleContainer': {
											fontSize: '13px',
										},
										'& .MuiDataGrid-cell': {
											fontSize: '13px !important',
											borderRight:
												theme.palette.mode === 'dark'
													? '1px solid rgba(81, 81, 81, 1)'
													: '1px solid rgba(224, 224, 224, 1)',
										},
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}

export default SlideBlockResultPage
